import React from 'react'
import PropTypes from 'prop-types'

import refreshIcon from 'resources/imported_calendar_refresh.png'
import deleteIcon from 'resources/imported_calendar_delete.png'

const CalendarItem = ({ calendar, onCalendarSyncClicked, onCalendarRemoveClicked }) => (
  <div style={styles.itemContainer}>
    <div style={styles.item}>
      <div>
        <div style={styles.circle(calendar.backgroundColor)}></div>
      </div>
      <div style={styles.summary}>{ calendar.summary }</div>
    </div>
    <div style={styles.actions}>
      <img src={refreshIcon} title='Sync' width={12} onClick={onCalendarSyncClicked} style={{ cursor: 'pointer' }} />        
      <img src={deleteIcon} title='Remove' width={18} onClick={onCalendarRemoveClicked} style={{ cursor: 'pointer', marginLeft: 8 }} />
    </div>
  </div>
)

CalendarItem.propTypes = {
  calendar: PropTypes.object.isRequired,
  onCalendarSyncClicked: PropTypes.func.isRequired,
  onCalendarRemoveClicked: PropTypes.func.isRequired
}

export default class ImportedCalendarsList extends React.Component {

  static propTypes = {
    calendarsState: PropTypes.object,
    onCalendarSyncClicked: PropTypes.func.isRequired,
    onCalendarRemoveClicked: PropTypes.func.isRequired,
    style: PropTypes.any.isRequired
  }

  comparer = (c0, c1) => {
    return c0.summary.localeCompare(c1.summary, 'co', { sensitivity: 'base' })
  }
  
  handleCalendarRemoveRequest = (event, importedCalendarId) => {
    event.preventDefault()
    this.props.onCalendarRemoveClicked(importedCalendarId)
  }

  handleCalendarSyncRequest = (event, importedCalendarId) => {
    event.preventDefault()
    this.props.onCalendarSyncClicked(importedCalendarId)
  }

  render() {
    const imported = this.props.calendarsState.getImportedCalendars()
    if (!imported) {
      return null
    }
    imported.sort(this.comparer)
    return (
      <div style={{ ...this.props.style, ...styles.container }}>
        <div style={styles.importedHeading}>Imported Calendars</div>
        { imported.map(calendar =>
          <CalendarItem
            key={calendar.id}
            calendar={calendar}
            onCalendarSyncClicked={event => this.handleCalendarSyncRequest(event, calendar.id)}
            onCalendarRemoveClicked={event => this.handleCalendarRemoveRequest(event, calendar.id)} />)
        }
      </div>
    )
  }

}

const styles = {

  container: {
    display: 'flex',
    flexDirection: 'column'
  },

  importedHeading: {
    color: '#4a4a4a',
    fontWeight: 400,
    fontSize: 14,
    fontFamily: 'Roboto',
    marginBottom: 12
  },

  itemContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 6,
    marginBottom: 6
  },

  item: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },

  circle: backgroundColor => ({
    width: 18,
    height: 18,
    borderRadius: 9,
    backgroundColor
  }),

  summary: {
    color: '#9b9b9b',
    fontWeight: 300,
    fontSize: 13,
    fontFamily: 'Roboto',
    marginLeft: 8,
    wordBreak: 'break-word'
  },

  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 8
  }

}


// WEBPACK FOOTER //
// ./src/schedule/gcal/ImportedCalendarsList.js